import { useState, useEffect } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { mq } from "./responsive";

import { Link, NavLink } from "react-router-dom";

import Logo from "../assets/logo.svg";
import LogoTransparent from "../assets/logo-transparent.svg";
import Burger from "../assets/burger.svg";
import BurgerTransparent from "../assets/burger-transparent.svg";
import Setting from "../assets/setting.svg";
import Avatar from "../assets/avatar.png";

import Cart from "../assets/cart.svg";
import CartTransparent from "../assets/cart-transparent.svg";
import Account from "../assets/account.svg";
import AccountTransparent from "../assets/account-transparent.svg";

import { List } from "./UI";
import { Flex } from "./shared";
import { Paragraph } from "./UI/Typoraphy";
import { Container } from "./Layout";

import ProductSearch from "./ProductSearch";

const menuItems = [
  { label: "Home", href: "/" },
  {
    label: "Experiences",
    href: "/experiences",
  },
  {
    label: "Wish list",
    href: "/wishlist",
  },
  {
    label: "About us",
    href: "/aboutus",
  },
  {
    label: "Cart",
    href: "/cart",
  },
];

const Nav = ({ transparent }) => {
  const [visible, setVisible] = useState(false);

  return (
    <Container
      style={{
        paddingTop: 0,
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 3,
        paddingBottom: 0,
        background: transparent ? "transparent" : "#ffffff",
        boxShadow: transparent ? "none" : "0 4px 14px rgba(0, 0, 0, 0.04)",
        width: "100%",
        transition: "all 0.2s ease-out",
        height: "8rem",

        [mq.md]: {
          height: "10rem",
        },
      }}
    >
      <Flex
        css={{
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "nowrap",
          padding: "2rem 0",
          position: "relative",
          height: "100%",
        }}
      >
        <Link to="/" css={{ zIndex: 5 }}>
          <img
            src={transparent ? LogoTransparent : Logo}
            alt="logo"
            css={{
              height: "5rem",
            }}
          />
        </Link>

        <Container
          style={{
            textAlign: "right",
            zIndex: 2,
            position: "fixed",
            top: 0,
            right: 0,
            paddingTop: "15rem !important",
            paddingBottom: "15rem !important",
            paddingLeft: "5rem !important",
            width: "100%",
            height: "100vh",
            transition: "all 0.3s ease-in-out",
            transform: visible ? "translateX(0)" : "translateX(100%)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            backgroundColor: "#ffffff",

            [mq.md]: {
              maxWidth: "50rem",
            },
          }}
        >
          <List>
            {menuItems.map((item, index) => (
              <List.Item
                style={{
                  padding: "2.5rem 0",
                  color: "#333333",
                }}
                key={index}
              >
                <NavLink
                  css={{
                    fontSize: "2.5rem",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                  to={item.href}
                >
                  {item.label}
                </NavLink>
              </List.Item>
            ))}
          </List>
          <Flex
            css={{
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              transition: "all 0.3s ease-in-out",
              transform: visible
                ? "translate(0, -50%)"
                : "translate(100%, -50%)",
              zIndex: 4,
            }}
          >
            <img src={Setting} alt="setting" />
            <Flex css={{ justifyContent: "flex-end", alignItems: "center" }}>
              <div css={{ marginRight: "3rem", textAlign: "right" }}>
                <Paragraph
                  style={{
                    fontWeight: "medium",
                    fontSize: "2.5rem",
                    marginBottom: "0.5rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  Hi, Mark Cuban
                </Paragraph>
                <Link to="/profile">View profile</Link>
              </div>
              <img src={Avatar} alt="avatar" />
            </Flex>
          </Flex>
        </Container>

        {!transparent && (
          <div
            css={{
              display: "none",

              [mq.md]: {
                margin: "0 16px",
                padding: "0",
                display: "block",
                width: "calc(100% - 24rem)",
                position: "absolute",
                top: "15px",
                left: "16rem",
                height: "fit-content",
                zIndex: 5,
              },

              [mq.lg]: {
                width: "calc(100% - 40rem)",
              },
            }}
          >
            <ProductSearch bordered={true} />
          </div>
        )}

        <List
          style={{
            display: "flex",
            zIndex: 5,

            "& > *:not(:first-of-type)": {
              display: "none",
            },

            [mq.lg]: {
              display: "flex",

              "& > *": {
                display: "block !important",
              },
            },
          }}
        >
          <List.Item
            style={{
              padding: "0 0 0 4rem",
            }}
            key="burger"
          >
            <img
              src={
                transparent && !visible && !(window.innerWidth < 768)
                  ? BurgerTransparent
                  : Burger
              }
              alt="burger"
              onClick={(e) => setVisible((visible) => !visible)}
              css={{ width: "3rem", height: "3rem" }}
            />
          </List.Item>
          <List.Item
            style={{
              padding: "0 0 0 4rem",
            }}
            key="cart"
          >
            <NavLink to="/cart">
              <img
                src={transparent && !visible ? CartTransparent : Cart}
                alt="cart"
              />
            </NavLink>
          </List.Item>
          <List.Item
            style={{
              padding: "0 0 0 4rem",
            }}
            key="account"
          >
            <NavLink to="/account">
              <img
                src={transparent && !visible ? AccountTransparent : Account}
                alt="account"
              />
            </NavLink>
          </List.Item>
        </List>
      </Flex>
    </Container>
  );
};

export default Nav;
